export default __webpack_public_path__ + "static/jetson_background_mobile-f1c72f0d5cd1f1829251bfbe8f0972ef.png";